interface RetryOptions {
  retries?: number;
  baseDelayMs?: number;
}

const wait = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms));

/** Re-runs `task` on rejection with exponential backoff; rethrows the last error once retries are spent. */
export async function retryWithBackoff<T>(
  task: () => Promise<T>,
  { retries = 2, baseDelayMs = 500 }: RetryOptions = {}
): Promise<T> {
  for (let attempt = 0; ; attempt++) {
    try {
      return await task();
    } catch (error) {
      if (attempt >= retries) {
        throw error;
      }
      await wait(baseDelayMs * 2 ** attempt);
    }
  }
}
